import React from "react";

export default function About() {

    return (
        <div className="container">
            About page has not been created.
        </div>
    )
}